import { Setting } from "../models/setting";

const initialState: Setting = {
  memoFontSize: 17,
  isHiddenPreview: false,
  isOpenMenuBySwipe: false,
  isNotIncludeSpace: false
};

export default function(state = initialState, action) {
  switch (action.type) {
    case "SET_MEMO_FONTSIZE":
      return {
        ...state,
        memoFontSize: action.payload.memoFontSize
      };
    case "TOGGLE_HIDDEN_PREVIEW":
      return {
        ...state,
        isHiddenPreview: !state.isHiddenPreview
      };
    case "TOGGLE_OPEN_MENU_BY_SWIPE":
      return {
        ...state,
        isOpenMenuBySwipe: !state.isOpenMenuBySwipe
      };
    case "TOGGLE_INCLUDE_SPACE":
      return {
        ...state,
        isNotIncludeSpace: !state.isNotIncludeSpace
      };
    default:
      return state;
  }
}
